import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";

export const BUILDER_ESTIMATOR_ALL_STEPS: BuilderEstimatorSteps[] = [
  BuilderEstimatorSteps.LAND_DETAILS,
  BuilderEstimatorSteps.VIEW_DESIGN,
  BuilderEstimatorSteps.SELECT_DESIGN,
  BuilderEstimatorSteps.SELECT_FACADE,
  BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS,
  BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS,
  BuilderEstimatorSteps.SELECT_INCLUSIONS,
  BuilderEstimatorSteps.OPTIONAL_UPGRADES,
  BuilderEstimatorSteps.SUMMARY,
];
